import de from '@translations/de/home.json';
import en from '@translations/en/home.json';
import pl from '@translations/pl/home.json';
import sl from '@translations/sl/home.json';
import uk from '@translations/uk/home.json';
import bg from '@translations/bg/home.json';
import cz from '@translations/cz/home.json';
import fr from '@translations/fr/home.json';
import gr from '@translations/gr/home.json';
import it from '@translations/it/home.json';
import pr from '@translations/pr/home.json';
import ru from '@translations/ru/home.json';
import sk from '@translations/sk/home.json';
import sp from '@translations/sp/home.json';
import tr from '@translations/tr/home.json';
import hu from '@translations/hu/home.json';
import { ITranslations } from '@/types/common';
import { HomeTransFields } from './types';

export const homeTranslations: ITranslations<HomeTransFields> = {
  name: 'home',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
